export default function createTypes(actions) {
    const types = {};
    actions.forEach((action) => {
        types[action] = action;
        types[action + '_SUCCESS'] = action + '_SUCCESS';
        types[action + '_FAILURE'] = action + '_FAILUIRE';
    });
    return types;
}
